import { createRouter, createWebHistory } from 'vue-router';
import { ElMessage } from 'element-plus';

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    meta: {
      title: '登录',
      requireAuth: false,
    },
  },
  {
    path: '/',
    name: 'Main',
    component: () => import('../layouts/MainLayout.vue'),
    meta: {
      title: '首页',
      requireAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
          title: '首页',
        },
      },
      // 后台账号管理
      {
        path: 'admin-users/list',
        name: 'AdminUserList',
        component: () => import('../views/users/UserList.vue'),
        meta: {
          title: '后台账号列表',
        },
      },
      // 角色管理
      {
        path: 'roles/list',
        name: 'RoleList',
        component: () => import('../views/roles/RoleList.vue'),
        meta: { title: '角色列表' },
      },
      {
        path: 'users/balances',
        name: 'BalanceRecords',
        component: () => import('../views/users/BalanceRecords.vue'),
        meta: { title: '余额记录管理' },
      },
      {
        path: 'users/verifications',
        name: 'VerificationRecords',
        component: () => import('../views/users/VerificationRecords.vue'),
        meta: { title: '核销记录管理' },
      },
      {
        path: 'users/checkins',
        name: 'CheckinRecords',
        component: () => import('../views/users/CheckinRecords.vue'),
        meta: { title: '打卡记录管理' },
      },
      {
        path: 'users/clerks',
        name: 'ClerkList',
        component: () => import('../views/users/ClerkList.vue'),
        meta: { title: '店员管理' },
      },
      // 个人信息
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/system/Profile.vue'),
        meta: {
          title: '个人资料',
        },
      },
      // 操作日志
      {
        path: 'operation-logs',
        name: 'OperationLogs',
        component: () => import('../views/system/OperationLogs.vue'),
        meta: {
          title: '操作记录',
        },
      },
      {
        path: 'clerk-logs',
        name: 'ClerkLogs',
        component: () => import('../views/system/ClerkLogs.vue'),
        meta: {
          title: '店员日志',
        },
      },
      // 系统设置
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('../views/system/Settings.vue'),
        meta: {
          title: '系统设置',
        },
      },
      // 微信配置
      {
        path: 'system/wechat',
        name: 'WechatSettings',
        component: () => import('../views/system/WechatSettings.vue'),
        meta: {
          title: '微信配置',
        },
      },
      // ===== 图文管理 =====
      {
        path: 'content/banners',
        name: 'BannerList',
        component: () => import('../views/content/BannerList.vue'),
        meta: { title: '首页Banner管理' },
      },
      {
        path: 'content/working-dogs',
        name: 'WorkingDogList',
        component: () => import('../views/content/WorkingDogList.vue'),
        meta: { title: '工作犬档案管理' },
      },
      {
        path: 'content/company-info',
        name: 'CompanyInfo',
        component: () => import('../views/content/CompanyInfo.vue'),
        meta: { title: '企业信息管理' },
      },
      {
        path: 'content/home-deco',
        name: 'HomeDecoration',
        component: () => import('../views/content/HomeDecoration.vue'),
        meta: { title: '首页装修' }
      },
      {
        path: 'content/home-icons',
        name: 'HomeIconList',
        component: () => import('../views/content/HomeIconList.vue'),
      }, {
        path: 'content/tab-bar-config',
        name: 'TabBarConfig',
        component: () => import('../views/content/TabBarConfig.vue'),
        meta: { title: 'TabBar设置' }
      },
      {
        path: 'content/pet-selectors',
        name: 'PetSelectorConfig',
        component: () => import('../views/content/PetSelectorConfig.vue'),
        meta: { title: '宠物选择器' }
      },
      {
        path: 'content/pages',
        name: 'ContentPageEdit',
        component: () => import('../views/content/ContentPageEdit.vue'),
        meta: { title: '内容管理' },
      },
      {
        path: 'content/custom-pages',
        name: 'CustomPages',
        component: () => import('../views/content/CustomPages.vue'),
        meta: { title: '自定义页面' },
      },
      // ===== 素材管理 =====
      {
        path: 'content/media',
        name: 'MediaList',
        component: () => import('../views/content/MediaList.vue'),
        meta: { title: '素材管理' },
      },
      {
        path: 'content/search-hotwords',
        name: 'SearchHotwordList',
        component: () => import('../views/content/SearchHotwordList.vue'),
        meta: { title: '搜索热词管理' },
      },
      // ===== 宠境酒店管理 =====
      {
        path: 'hotel/rooms',
        name: 'RoomList',
        component: () => import('../views/hotel/RoomList.vue'),
        meta: { title: '房型管理' },
      },
      {
        path: 'hotel/extra-services',
        name: 'ExtraServiceList',
        component: () => import('../views/hotel/ExtraServiceList.vue'),
        meta: { title: '增项服务管理' },
      },
      {
        path: 'hotel/settings',
        name: 'HotelSettings',
        component: () => import('../views/hotel/HotelSettings.vue'),
        meta: { title: '酒店设置' },
      },
      // ===== 宠境乐园管理 =====
      {
        path: 'park/projects',
        name: 'ParkProjectList',
        component: () => import('../views/park/ProjectList.vue'),
        meta: { title: '项目管理' },
      },
      // ===== 宠境训练管理 =====
      {
        path: 'training/category',
        name: 'TrainingCategory',
        component: () => import('../views/training/TrainingCategory.vue'),
        meta: { title: '分类管理' },
      },
      {
        path: 'training/content',
        name: 'TrainingContent',
        component: () => import('../views/training/TrainingContent.vue'),
        meta: { title: '教学内容管理' },
      },
      // ===== 人宠民宿管理 =====
      {
        path: 'homestay/info',
        name: 'HomestayInfo',
        component: () => import('../views/homestay/HomestayInfo.vue'),
        meta: { title: '人宠民宿管理' },
      },
      // ===== 日托管理 =====
      {
        path: 'daycare/projects',
        name: 'DaycareProjectList',
        component: () => import('../views/daycare/ProjectList.vue'),
        meta: { title: '日托项目管理' },
      },
      // ===== 周边游玩管理 =====
      {
        path: 'attractions/list',
        name: 'AttractionList',
        component: () => import('../views/attractions/AttractionList.vue'),
        meta: { title: '周边游玩管理' },
      },
      // ===== 团队管理 =====
      {
        path: 'team/list',
        name: 'TeamMemberList',
        component: () => import('../views/team/MemberList.vue'),
        meta: { title: '团队人员管理' },
      },
      // ===== 活动管理 =====
      {
        path: 'activities/list',
        name: 'ActivityList',
        component: () => import('../views/activity/ActivityList.vue'),
        meta: { title: '活动管理' },
      },
      {
        path: 'activities/registrations',
        name: 'ActivityRegistrations',
        component: () => import('../views/activity/ActivityRegistrations.vue'),
        meta: { title: '活动报名管理' },
      },
      // ===== 商城管理 =====
      {
        path: 'mall/categories',
        name: 'MallCategories',
        component: () => import('../views/mall/MallCategories.vue'),
        meta: { title: '商品类目管理' },
      },
      {
        path: 'mall/products',
        name: 'MallProducts',
        component: () => import('../views/mall/MallProducts.vue'),
        meta: { title: '商品管理' },
      },
      {
        path: 'mall/delivery',
        name: 'MallDelivery',
        component: () => import('../views/mall/MallDelivery.vue'),
        meta: { title: '收货方式管理' },
      },
      {
        path: 'express/companies',
        name: 'ExpressCompanies',
        component: () => import('../views/express-companies/ExpressCompanies.vue'),
        meta: { title: '物流公司管理' },
      },
      {
        path: 'express/settings',
        name: 'ExpressSettings',
        component: () => import('../views/store/ExpressSettings.vue'),
        meta: { title: '收发货配置' },
      },
      // ===== 宠物档案管理 =====
      {
        path: 'pet-profile/species',
        name: 'PetSpecies',
        component: () => import('../views/pet-profile/PetSpecies.vue'),
        meta: { title: '宠物品类编辑' },
      },
      {
        path: 'pet-profile/breeds',
        name: 'PetBreeds',
        component: () => import('../views/pet-profile/PetBreeds.vue'),
        meta: { title: '宠物品种编辑' },
      },
      {
        path: 'pet-profile/archives',
        name: 'PetArchives',
        component: () => import('../views/pet-profile/PetArchives.vue'),
        meta: { title: '宠物档案管理' },
      },
      {
        path: 'pet-profile/entry',
        name: 'PetEntry',
        component: () => import('../views/pet-profile/PetEntry.vue'),
        meta: { title: '入园登记表管理' },
      },
      // ===== 数据统计 =====
      {
        path: 'statistics/overview',
        name: 'StatisticsOverview',
        component: () => import('../views/statistics/Overview.vue'),
        meta: { title: '数据概览' },
      },
      {
        path: 'statistics/users',
        name: 'StatisticsUsers',
        component: () => import('../views/statistics/Users.vue'),
        meta: { title: '用户分析' },
      },
      {
        path: 'statistics/orders',
        name: 'StatisticsOrders',
        component: () => import('../views/statistics/Orders.vue'),
        meta: { title: '订单分析' },
      },
      {
        path: 'statistics/pets',
        name: 'StatisticsPets',
        component: () => import('../views/statistics/Pets.vue'),
        meta: { title: '宠物分析' },
      },
      {
        path: 'statistics/favorites',
        name: 'StatisticsFavorites',
        component: () => import('../views/statistics/Favorites.vue'),
        meta: { title: '收藏分析' },
      },
      // ===== 会员中心 =====
      {
        path: 'membership/users',
        name: 'MembershipUsers',
        component: () => import('../views/membership/MembershipUsers.vue'),
        meta: { title: '用户管理' },
      },
      {
        path: 'membership/levels',
        name: 'MemberLevels',
        component: () => import('../views/membership/MemberLevels.vue'),
        meta: { title: '会员等级与折扣' },
      },
      {
        path: 'membership/recharge',
        name: 'RechargeAmounts',
        component: () => import('../views/membership/RechargeAmounts.vue'),
        meta: { title: '充值金额设置' },
      },
      {
        path: 'membership/intro',
        name: 'MemberIntro',
        component: () => import('../views/membership/MemberIntro.vue'),
        meta: { title: '会员介绍页' },
      },
      // ===== 订单管理 =====
      {
        path: 'orders/hotel',
        name: 'HotelOrders',
        component: () => import('../views/orders/HotelOrders.vue'),
        meta: { title: '宠境酒店订单' },
      },
      {
        path: 'orders/park',
        name: 'ParkOrders',
        component: () => import('../views/orders/ParkOrders.vue'),
        meta: { title: '宠境乐园订单' },
      },
      {
        path: 'orders/daycare',
        name: 'DaycareOrders',
        component: () => import('../views/orders/DaycareOrders.vue'),
        meta: { title: '宠境日托订单' },
      },
      {
        path: 'orders/mall',
        name: 'MallOrders',
        component: () => import('../views/orders/MallOrders.vue'),
        meta: { title: '商城订单管理' },
      },
      {
        path: 'orders/refunds',
        name: 'RefundManagement',
        component: () => import('../views/orders/RefundManagement.vue'),
        meta: { title: '退款管理' },
      },
      {
        path: 'orders/after-sales',
        name: 'AfterSaleManagement',
        component: () => import('../views/orders/AfterSaleManagement.vue'),
        meta: { title: '售后单管理' },
      },
      {
        path: 'orders/refund-settings',
        name: 'RefundSettings',
        component: () => import('../views/orders/RefundSettings.vue'),
        meta: { title: '售后设置' },
      },
      {
        path: 'orders/reviews',
        name: 'ReviewManagement',
        component: () => import('../views/orders/ReviewManagement.vue'),
        meta: { title: '评价管理' },
      },
      {
        path: 'orders/time-settings',
        name: 'OrderTimeSettings',
        component: () => import('../views/orders/OrderTimeSettings.vue'),
        meta: { title: '时效配置' },
      },
      {
        path: 'orders/cart-config',
        name: 'CartConfig',
        component: () => import('../views/orders/CartConfig.vue'),
        meta: { title: '购物车设置' },
      },
    ],
  },
  // 未开发页面
  {
    path: '/:pathMatch(.*)*',
    name: 'UnDeveloped',
    component: () => import('../views/UnDeveloped.vue'),
    meta: {
      title: '功能开发中',
      requireAuth: true,
    },
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title || '管理系统'} - 管理系统`;

  if (to.meta.requireAuth) {
    const token = localStorage.getItem('token');
    if (token) {
      next();
    } else {
      ElMessage.warning('请先登录');
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;
